<template>
  <div class="filter-container">
    <div class="data-synchronizer">
      <div class="filters-text-container">
        <b class="filters">Filters</b>
        <img class="separator-icon" alt="" src="../../assets/separator.svg" />
      </div>

      <CommonFilterSection
        title="Condition"
        :items="conditionList"
        @toggle="toggleConditionSelection"
      />

      <div class="graph-range-container">
        <PriceRangeFilter min="30" max="70" @priceRangeValue="getPriceRange" />
      </div>

      <CommonFilterSection
        title="Make"
        :items="makeList"
        @toggle="toggleMakeSelection"
      />

      <CommonFilterSection
        title="Body style"
        :items="bodyStyleList"
        @toggle="toggleBodyStyleSelection"
      />

      <CommonFilterSection
        title="Year"
        :items="yearList"
        @toggle="toggleYearSelection"
      />

      <div class="condition-container">
        <b class="condition">Exterior</b>
        <div class="condition-items-container">
          <div class="condition-item">
            <div
              class="button-container"
              v-for="(item, index) in exteriorInteriorList"
              :key="index"
              @click="toggleExteriorInteriorSelection(index, 'ex')"
            >
              <img
                v-if="item.isexteriorSelected"
                class="check-icon"
                alt=""
                src="../../assets/check-2.svg"
              />
              <div class="button-text">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="filters-text-container">
        <img class="separator-icon" alt="" src="../../assets/separator.svg" />
      </div>

      <div class="condition-container">
        <b class="condition">Interior</b>
        <div class="condition-items-container">
          <div class="condition-item">
            <div
              class="button-container"
              v-for="(item, index) in exteriorInteriorList"
              :key="index"
              @click="toggleExteriorInteriorSelection(index, 'int')"
            >
              <img
                v-if="item.isInteriorSelected"
                class="check-icon"
                alt=""
                src="../../assets/check-2.svg"
              />
              <div class="button-text">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="filters-text-container">
        <img class="separator-icon" alt="" src="../../assets/separator.svg" />
      </div>

      <div class="graph-range-container">
        <b class="range-label">Fuel Economy</b>
        <CityRangeFilter
          mPGMPGe="MPG/MPGe"
          min="15"
          max="25"
          @citySliderValue="getCityRange"
        />
        <HighwayRangeFilter
          mPGMPGe="MPG/MPGe"
          min="15"
          max="55"
          @highwaySliderValue="getHighwayRange"
        />
      </div>

      <div class="filters-text-container">
        <img class="separator-icon" alt="" src="../../assets/separator.svg" />
      </div>

      <div class="seating-capacity-container">
        <b class="seating-label">Maximum Seating Capacity</b>
        <div class="seating-items-container">
          <div
            class="seatting-any-button-container"
            :class="seatingCapasity === 'any' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('any')"
          >
            <div class="seatting-any-button">Any</div>
          </div>
          <div
            class="seatting-2-button-container"
            :class="seatingCapasity === '2' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('2')"
          >
            <div class="seatting-2-button">2</div>
          </div>
          <div
            class="seatting-4-button-container"
            :class="seatingCapasity === '4' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('4')"
          >
            <div class="seatting-4-button">4</div>
          </div>
          <div
            class="seatting-5-button-container"
            :class="seatingCapasity === '5' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('5')"
          >
            <div class="seatting-5-button">5</div>
          </div>
          <div
            class="seatting-6-button-container"
            :class="seatingCapasity === '6' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('6')"
          >
            <div class="seatting-6-button">6</div>
          </div>
          <div
            class="seatting-8-button-container"
            :class="seatingCapasity === '8' ? 'seating-selected' : ''"
            @click="setSeatingCapasity('8')"
          >
            <div class="seatting-8-button">8</div>
          </div>
        </div>
      </div>
      <div class="filters-text-container">
        <img class="separator-icon" alt="" src="../../assets/separator.svg" />
      </div>

      <div class="graph-range-container">
        <MileageRangeFilter
          mPGMPGe="miles"
          min="15"
          max="35"
          @mileageSliderValue="getMileageRange"
        />
      </div>
    </div>

    <div
      class="apply-button-container"
      v-if="isFilterBtnAppear"
      @click="onApplyFilter"
    >
      <div class="apply-button">Apply filters</div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import CityRangeFilter from "./CityRangeFilter.vue";
import HighwayRangeFilter from "./HighwayRangeFilter.vue";
import CommonFilterSection from "./CommonFilterSection.vue";
import PriceRangeFilter from "./PriceRangeFilter.vue";
import MileageRangeFilter from "./MileageRangeFilter.vue";
import { FilterOptionsData } from "./filter-option-data.js";

const conditionList = ref(FilterOptionsData.conditionList);
const makeList = ref(FilterOptionsData.makeList);
const bodyStyleList = ref(FilterOptionsData.bodyStyleList);
const yearList = ref(FilterOptionsData.yearList);
const exteriorInteriorList = ref(FilterOptionsData.exteriorInteriorList);

const seatingCapasity = ref("any");
const milageRange = ref({ min: 0, max: 0 });
const priceRange = ref({ min: 0, max: 0 });
const cityRange = ref({ min: 0, max: 0 });
const highwayRange = ref({ min: 0, max: 0 });
const isFilterBtnAppear = ref(false);

function toggleConditionSelection(index) {
  conditionList.value[index].isSelected =
    !conditionList.value[index].isSelected;
  isFilterBtnAppear.value = true;
}
function toggleMakeSelection(index) {
  makeList.value[index].isSelected = !makeList.value[index].isSelected;
  isFilterBtnAppear.value = true;
}
function toggleBodyStyleSelection(index) {
  bodyStyleList.value[index].isSelected =
    !bodyStyleList.value[index].isSelected;
  isFilterBtnAppear.value = true;
}
function toggleYearSelection(index) {
  yearList.value[index].isSelected = !yearList.value[index].isSelected;
  isFilterBtnAppear.value = true;
}

function toggleExteriorInteriorSelection(index, type) {
  if (type === "ex") {
    exteriorInteriorList.value[index].isexteriorSelected =
      !exteriorInteriorList.value[index].isexteriorSelected;
  } else {
    exteriorInteriorList.value[index].isInteriorSelected =
      !exteriorInteriorList.value[index].isInteriorSelected;
  }
  isFilterBtnAppear.value = true;
}

function setSeatingCapasity(seatcapasity) {
  seatingCapasity.value = seatcapasity;
  isFilterBtnAppear.value = true;
}

function getMileageRange(range) {
  milageRange.value = {
    min: range.value[0] * 2000,
    max: range.value[1] * 2000,
  };
  isFilterBtnAppear.value = true;
}

function getPriceRange(range) {
  priceRange.value = {
    min: range.value[0] * 1000,
    max: range.value[1] * 1000,
  };
  isFilterBtnAppear.value = true;
}

function getCityRange(range) {
  cityRange.value = {
    min: range.value[0],
    max: range.value[1],
  };
  isFilterBtnAppear.value = true;
}

function getHighwayRange(range) {
  highwayRange.value = {
    min: range.value[0],
    max: range.value[1],
  };
  isFilterBtnAppear.value = true;
}

function onApplyFilter() {
  const selectedConditionList = conditionList.value
    .filter((item) => item.isSelected)
    .map((item) => item.label);
  const selectedMakeList = makeList.value
    .filter((item) => item.isSelected)
    .map((item) => item.label);
  const selectedBodyStyleList = bodyStyleList.value
    .filter((item) => item.isSelected)
    .map((item) => item.label);
  const selectedYearList = yearList.value
    .filter((item) => item.isSelected)
    .map((item) => item.label);
  const selectedExteriorList = exteriorInteriorList.value
    .filter((item) => item.isexteriorSelected)
    .map((item) => item.label);
  const selectedInteriorList = exteriorInteriorList.value
    .filter((item) => item.isInteriorSelected)
    .map((item) => item.label);

  const filterPayload = {
    selectedConditionList: selectedConditionList,
    priceRange: [priceRange.value["min"], priceRange.value["max"]],
    selectedMakeList: selectedMakeList,
    selectedBodyStyleList: selectedBodyStyleList,
    selectedYearList: selectedYearList,
    selectedExteriorList: selectedExteriorList,
    selectedInteriorList: selectedInteriorList,
    seatingCapasity: seatingCapasity.value,
    cityRange: [cityRange.value["min"], cityRange.value["max"]],
    highwayRange: [highwayRange.value["min"], highwayRange.value["max"]],
    milageRange: [milageRange.value["min"], milageRange.value["max"]],
  };
  console.log(filterPayload);
  isFilterBtnAppear.value = false;
}
</script>
<style scoped>
.apply-button {
  position: relative;
  letter-spacing: 0.01em;
  line-height: 24px;
  font-weight: 600;
  display: inline-block;
  min-width: 79px;
  white-space: nowrap;
}
.apply-button-container {
  border-radius: var(--br-9xs);
  background-color: var(--primary-accent-base);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  padding: var(--padding-7xs) var(--padding-11xl);
  white-space: nowrap;
  flex-shrink: 0;
  z-index: 1;
  color: var(--white-dark);
  /* width: 50%; */
  position: absolute;
  right: 24px;
  bottom: 30px;
  cursor: pointer;
}

.seatting-any-button {
  align-self: stretch;
  width: 28px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
}
.seatting-2-button {
  align-self: stretch;
  width: 10px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
}

.seatting-any-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  border: 1px solid var(--black-default);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs-5) var(--padding-sm);
}
.seatting-2-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  border: 1px solid var(--black-default);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs-5) var(--padding-4xl);
}
.seatting-4-button {
  align-self: stretch;
  flex: 1;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
}
.seatting-4-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-6xs-5) var(--padding-5xl);
  box-sizing: border-box;
  border: 1px solid var(--black-default);
}

.seating-selected {
  background-color: var(--primary-accent-base);
  color: var(--white-dark);
}
.seatting-5-button {
  align-self: stretch;
  width: 10px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
}
.seatting-5-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  border: 1px solid var(--black-default);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs-5) var(--padding-4xl);
}
.seatting-6-button {
  align-self: stretch;
  width: 10px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
}
.seatting-6-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  border: 1px solid var(--black-default);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs-5) var(--padding-4xl);
}
.seatting-8-button {
  align-self: stretch;
  width: 10px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
}
.seatting-8-button-container {
  align-self: stretch;
  width: 58px;
  border-radius: var(--br-9xs);
  border: 1px solid var(--black-default);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs-5) var(--padding-4xl);
}

.filter-container {
  align-self: stretch;
  height: 200px;
  /* height: 358px; */
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  margin-top: -1px;
  gap: 10px;
  background: #f1f0f2;
  /* padding: var(--padding-9xs) var(--padding-5xl); */
  padding: 24px 24px 30px 24px;
}

.data-synchronizer {
  align-self: stretch;
  /* height: 200px; */
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  position: relative;
  gap: var(--gap-21xl);
  max-width: 100%;
  width: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
}

.data-synchronizer::-webkit-scrollbar {
  display: none;
}

.filters-text-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: var(--gap-xl);

  .filters {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 27px;
    display: inline-block;
    min-width: 54px;
    font-weight: 700;
    text-align: left;
    color: #3b3b3b;
    font-size: 18px;
  }

  .separator-icon {
    align-self: stretch;
    position: relative;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    flex-shrink: 0;
  }
}

.condition-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 10px;

  .condition {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 24px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    min-width: 80px;
  }

  .condition-items-container {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: var(--gap-3xs);

    .condition-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      gap: var(--gap-3xs);
      flex-wrap: wrap;

      .button-container {
        height: 33px;
        border-radius: var(--br-9xs);
        background-color: var(--white-default);
        border: 0.5px solid var(--primary-accent-base);
        box-sizing: border-box;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: var(--padding-10xs) var(--padding-sm) var(--padding-10xs)
          var(--padding-4xs);
        gap: var(--gap-3xs);
        cursor: pointer;

        .check-icon {
          height: 16px;
          width: 16px;
          position: relative;
        }

        .button-text {
          position: relative;
          letter-spacing: 0.01em;
          line-height: 27px;
          font-weight: 600;
          display: inline-block;
          font-size: 16px;
          text-align: left;
        }
      }
    }
  }
}

.graph-range-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 30px;
  flex: 1;

  .range-label {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 24px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
  }
}

.seating-capacity-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 30px;
  flex: 1;

  .seating-label {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 24px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
  }
  .seating-items-container {
    align-self: stretch;
    flex: 1;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--gap-9xs);

    .button-container {
      height: 40px;
      min-width: 58px;
      border-radius: var(--br-9xs);
      background-color: var(--white-default);
      border: 1px solid var(--black-default);
      box-sizing: border-box;
      overflow: hidden;
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: var(--gap-3xs);

      padding: 5px 10px 5px 10px;

      .button-text {
        position: relative;
        display: inline-block;
        font-size: 16px;
        font-weight: 400;
        line-height: 23px;
        letter-spacing: 0.01em;
        text-align: left;
        color: #3b3b3b;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .seating-items-container::-webkit-scrollbar {
    display: none; /* Hide the scrollbar */
  }
}
</style>
